import { lazy } from "react";
import { FeatureFlagRoute } from "../../_features/featureFlags/routing/FeatureFlagRoute";
import PermissionRoute from "./PermissionRoute";
import { ROUTE_PERMISSIONS } from "./routePermissions";

const Subscriptions = lazy(() => import("../../_features/subscriptions/pages/SubscriptionPage"));
const SubscriptionDetails = lazy(() => import("../../_features/subscriptions/pages/SubscriptionDetails"));
const CreateSubscriptionPage = lazy(() => import("../../_features/subscriptions/pages/SubscriptionCreatePage"));
const EditSubscriptionPage = lazy(() => import("../../_features/subscriptions/pages/SubscriptionEditPage"));

export const subscriptionRoutes = [
    {
        path: "/subscriptions", element:
            <FeatureFlagRoute feature="subscriptions">
                <PermissionRoute permission={ROUTE_PERMISSIONS.subscriptions.view} moduleName="Subscriptions">
                    <Subscriptions />
                </PermissionRoute>
            </FeatureFlagRoute>
    },
    {
        path: "/subscriptions/:id", element:
            <FeatureFlagRoute feature="subscriptions">
                <PermissionRoute permission={ROUTE_PERMISSIONS.subscriptions.view} moduleName="Subscriptions">
                    <SubscriptionDetails />
                </PermissionRoute>
            </FeatureFlagRoute>
    },
    {
        path: "/subscriptions/create", element:
            <FeatureFlagRoute feature="subscriptions">
                <PermissionRoute permission={ROUTE_PERMISSIONS.subscriptions.create} moduleName="Subscriptions">
                    <CreateSubscriptionPage />
                </PermissionRoute>
            </FeatureFlagRoute>
    },
    {
        path: "/subscriptions/:id/edit", element:
            <FeatureFlagRoute feature="subscriptions">
                <PermissionRoute permission={ROUTE_PERMISSIONS.subscriptions.edit} moduleName="Subscriptions">
                    <EditSubscriptionPage />
                </PermissionRoute>
            </FeatureFlagRoute>
    }
];
